<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-bind:style="{ background: '#2ea53c' }">
                <h2 class="search-title">{{ searchboxheadlinerebooking[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-search"></i>
            </div>

            <section id="content" style="padding-top: 20px; background-color: #fff;">
                <div id="main">
                    <div class="contact-address block" style="margin-left: 20px; margin-right: 20px;">
                        <h4>{{ hellotext1[getCurrentLocale] }}</h4>
                        <br /><p v-html="hellotext2[getCurrentLocale]"></p>

                        <br />

                        <hr>

                        <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                        <div class="row">
                            <div class="col-xs-6">
                                <label>{{ form_field1[getCurrentLocale] }}:* <small></small></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_flightid1.$error }"
                                    @input="$v.input_flightid1.$touch()"
                                    v-model="input_flightid1"
                                    id="'input_flightid1"
                                    name="input_flightid1" value="" placeholder="E.G.: 545906" style="text-transform: uppercase;" />
                                <!-- >>> 'errormsg', input_flightid1 -->
                                <p class="errormsg" v-if="$v.input_flightid1.$dirty && !$v.input_flightid1.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_flightid1.$dirty && !$v.input_flightid1.minLength">{{ errmsg_min_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_flightid1.$dirty && !$v.input_flightid1.maxLength">{{ errmsg_max_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_flightid1.$dirty && !$v.input_flightid1.lettersandnumbers">{{ errmsg_lettersandnumbers[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', input_flightid1 -->
                            </div>

                            <div class="col-xs-6">
                                <label>{{ form_field2[getCurrentLocale] }}:* <small></small></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_flightid2.$error }"
                                    @input="$v.input_flightid2.$touch()"
                                    v-model="input_flightid2"
                                    id="'input_flightid2"
                                    name="input_flightid2" value="" placeholder="E.G.: 545906" />
                                <!-- >>> 'errormsg', input_flightid2 -->
                                <p class="errormsg" v-if="$v.input_flightid2.$dirty && !$v.input_flightid2.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_flightid2.$dirty && !$v.input_flightid2.minLength">{{ errmsg_min_birthdate[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_flightid2.$dirty && !$v.input_flightid2.maxLength">{{ errmsg_max_birthdate[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', input_flightid2 -->
                            </div>
                        </div>

                        <br />

                        <hr>

                        <!-- >>> Submit -->
                        <a class="button btn-large uppercase full-width silver" v-if="!checkValidity()">{{ rebookflight[getCurrentLocale] }}</a>
                        <button type="submit" class="btn-large icon-check-rebooking uppercase full-width icon-check3" v-if="checkValidity()" v-bind:style="{ background: '#2ea53c' }">{{ rebookflight[getCurrentLocale] }}</button>
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */
    const lettersandnumbers = helpers.regex('lettersandnumbers', /^[A-Za-z0-9]+$/i); /* Validator */

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlinerebooking: {
                    en: 'Rebook entire Flights',
                    de: 'Ganze Flüge umbuchen',
                },
                searchboxheadlineflights2: {
                    en: 'Direct!',
                    de: 'Direkt!',
                },
                hellotext1 : {
                    en: 'Book entire flights arounds',
                    de: 'Buchen Sie ganze Flüge um',
                },
                hellotext2 : {
                    en: 'Here you can rebook the complete passengers from one flight to another flight.<br />Please enter the two flight ID"s.<br /><br /><strong>Note:</strong> The first flight ID will be rebooked to the second flight ID.',
                    de: 'Hier können Sie die kompletten Passagieren von einem Flug zum anderen Flug umbuchen.<br />Bitte geben Sie dazu die beiden Flug ID´s ein.<br /><br /><strong>Hinweis:</strong> Die erste Flug ID wird auf die die zweite Flug ID umgebucht.',
                },
                // ----------------------------------
                when: {
                    en: 'Your flights:',
                    de: 'Ihre Flüge:',
                },
                form_field1: {
                    en: 'Rebook flight (ID)',
                    de: 'Flug (ID) umbuchen',
                },
                form_field2: {
                    en: 'On Flight (ID)',
                    de: 'Auf Flug (ID)',
                },
                // ----------------------------------
                rebookflight: {
                    en: 'REBOOK',
                    de: 'UMBUCHEN',
                },
                // ----------------------------------
                input_flightid1: '',
                input_flightid2: '',
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
                errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                errmsg_lettersandnumbers: {
                    en: 'Letters and Numberss are allowed.',
                    de: 'Erlaubt sind Buchstaben und Zahlen.',
                },
                // >>> --------------------------
                errmsg_min_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_max_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_min_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                errmsg_max_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                // >>> --------------------------
                // currentLocale: 'de',
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            input_flightid1: {
                required: required,
                minLength: minLength(6),
                maxLength: maxLength(8),
                lettersandnumbers: lettersandnumbers
            },
            input_flightid2: {
                required: required,
                minLength: minLength(6),
                maxLength: maxLength(8),
                lettersandnumbers: lettersandnumbers
            },

        }, // eo validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingforrebooking'.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/forms/FlighttransferTab.vue >>> created');


        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/forms/FlighttransferTab.vue >>> beforeDestroy');

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_changeFlight', // Call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc:
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    myParams = {};


                me.$toc('>>> shared/forms/FlighttransferTab.vue >>> onSubmit');
                myParams.flightid1 = this.input_flightid1.toUpperCase();
                myParams.flightid2 = this.input_flightid2.toUpperCase();

                this.actn_call_changeFlight(myParams);

            }, // eo function onSubmit()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * checkValidity()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return {Array}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = false,
                    localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username'));


                me.$toc('>>> shared/forms/FlighttransferTab.vue >>> checkValidity');
                // Last Check: Inputs ---------------------
                if (this.input_flightid1 !== '') {
                    if (!me.$v.input_flightid1.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }

                if (formIsValid === true) {
                    if (this.input_flightid2 !== '') {
                        if (!me.$v.input_flightid2.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    } else {
                        formIsValid = false;
                    }
                }



                // Agency logged in? ----------------------
                if (formIsValid === true) {
                    if (localStorageAgencyUser === null) {
                        formIsValid = false;
                    }
                }


                return formIsValid;

            }, // eo function checkValidity()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-check-rebooking {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-rebooking:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }


    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #2ea53c;
    }
</style>